// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2573a348","453":"a0213926","455":"9f47996f","977":"27e7bc81"}[chunkId] + ".chunk.js";
};